"use client";

import { useState, useEffect, useCallback, MouseEvent } from "react";
import copy from "../helpers/copy";

export default function useClipboard(value: string | Response | null | undefined, timeout = 1500) {
  const [hasCopied, setHasCopied] = useState(false);

  const onCopy = useCallback(() => {
    try {
      if (typeof value === "string") {
        const didCopy = copy(value);
        setHasCopied(didCopy);
      }
    } catch (err) {
      console.error("Clipboard error:", err);
      setHasCopied(false);
    }
  }, [value]);

  const onClickInputToCopy = useCallback(
    (e: MouseEvent<HTMLInputElement>) => {
      e?.currentTarget.select();
      onCopy();
    },
    [onCopy]
  );

  useEffect(() => {
    if (hasCopied) {
      const id = setTimeout(() => setHasCopied(false), timeout);
      return () => clearTimeout(id);
    }
  }, [hasCopied, timeout]);

  return { value, onCopy, hasCopied, onClickInputToCopy };
}
